<div class="header">
  <img src="../../../assets/images/logo-banistmo.svg" id="'imgBanistmo'">
</div>
